import ReactApexChart from 'react-apexcharts';

const AreaChart = ({ data, colors, dataLabels = false, height }) => {
    if (!data || !Array.isArray(data.series) || !Array.isArray(data.categories)) {
        return null;
    }

    const options = {
        chart: {
            type: 'area',
            toolbar: {
                show: false
            },
            zoom: {
                enabled: false
            }
        },
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                inverseColors: false,
                opacityFrom: 0.50,
                opacityTo: 0.25,
                stops: [20, 100, 100, 100]
            },
        },
        dataLabels: {
            enabled: dataLabels
        },
        stroke: {
            curve: 'smooth',
            width: 2
        },
        xaxis: {
            categories: data.categories
        },
        colors: colors,
        legend: {
            show: false
        },
    };

    return (
        <div>
            <ReactApexChart options={options} series={data.series} type="area" height={height || 375} />
        </div>
    );
}

export default AreaChart;
